var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        {
          attrs: {
            divider: _vm.showCardText
          }
        },
        [
          _c(
            "v-row",
            {
              class: _vm.showCardText ? "" : "pb-3"
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    md: "6"
                  }
                },
                [_vm._v(" Install New WordPress ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right",
                  attrs: {
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        primary: "",
                        right: ""
                      },
                      on: {
                        click: _vm.togglePanel
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.showButtonLabel) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showCardText
        ? _c(
            "gg-card-text",
            [
              _vm.loading
                ? _c("v-progress-linear", {
                    staticClass: "mb-1",
                    attrs: {
                      indeterminate: ""
                    }
                  })
                : _vm._e(),
              _c("step-one", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loadingStep,
                    expression: "!loadingStep"
                  }
                ],
                ref: "stepOne",
                on: {
                  "next-step": function nextStep($event) {
                    _vm.step = 2
                  },
                  "prev-step": function prevStep($event) {
                    _vm.step = 1
                  }
                }
              }),
              _vm.step === 2
                ? _c("step-two", {
                    on: {
                      "set-step": _vm.setStep,
                      "set-loading": _vm.handleLoading
                    }
                  })
                : _vm._e(),
              _vm.step === 3
                ? _c("step-three", {
                    on: {
                      collapse: function collapse($event) {
                        _vm.showCardText = false
                      },
                      "set-loading": _vm.handleLoading
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }